import { ModalViewModel } from '@/infra/ModalViewModel'
import { type BookkeepingCycle } from '@/features/jobs/bookkeeping/BookkeepingProgressionInfo'
import { type BookkeepingProgressionStore } from '@/features/jobs/bookkeeping/BookkeepingProgressionStore'
import { action, computed } from 'mobx'
import type { Id } from '@/infra/id'
import { type BookkeepingCorrectCycleDialogViewModel } from '@/features/jobs/details/components/BookkeepingCorrectCycleDialog/BookkeepingCorrectCycleDialogViewModel'

/**
 * Picks the completed bookkeeping cycle to correct.
 */
export class BookkeepingSelectCycleDialogViewModel {
  readonly modal = new ModalViewModel()

  constructor(
    private readonly _jobId: Id,
    private readonly _bookkeepingProgressionStore: BookkeepingProgressionStore,
    private readonly _bookkeepingCorrectCycleDialogVm: BookkeepingCorrectCycleDialogViewModel,
  ) {}

  /**
   * Returns the bookkeeping progression info.
   */
  @computed
  get bookkeepingProgressionInfo() {
    return this._bookkeepingProgressionStore.bookkeepingProgressions.get(
      this._jobId,
    )
  }

  /**
   * Returns the cycles that can be corrected.
   */
  @computed
  get completedCycles() {
    return this.bookkeepingProgressionInfo?.cycles.filter(
      (c) => c.status.type === 'Completed',
    )
  }

  /**
   * Opens the correct cycle dialog with the
   * completed items in the selected cycle.
   */
  @action.bound
  selectCycle(selectedCycle?: BookkeepingCycle) {
    if (selectedCycle) {
      this._bookkeepingCorrectCycleDialogVm.open(selectedCycle)
      this.modal.close()
    }
  }
}
